import React from 'react';
import './quotes.sass';


export const Quotes = (props:any) => {
    return(
            <div className="zalupa2">
               <div className='quotes-blocks'> 
                    <div id='quotes-text-blocks'>
                        <div className="quotes-text">{props.text}</div>
                        <div className="quotes-author">{props.author}</div>
                    </div>
                </div>
            </div>
    )
}
